import * as React from 'react';
import QRCode from 'qrcode';

/**
 * A QR code for `text`, drawn IN the bundle by the `qrcode` package (pinned in package.json): no CDN, no
 * third-party image service ever sees the promoter's link. Rendered as an inline SVG image, crisp at any size;
 * the same data URL is offered as a download.
 */
export function useQrSvg(text: string): string | null {
  const [src, setSrc] = React.useState<string | null>(null);
  React.useEffect(() => {
    let live = true;
    QRCode.toString(text, { type: 'svg', margin: 1, errorCorrectionLevel: 'M' })
      .then((svg) => {
        if (live) setSrc(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`);
      })
      .catch((err: unknown) => console.warn('QR not drawn', err));
    return () => {
      live = false;
    };
  }, [text]);
  return src;
}

export function QrImage({ src, label, className }: { src: string | null; label: string; className?: string }) {
  if (!src) return <div className={className} aria-hidden />;
  return <img src={src} alt={label} className={className} width={160} height={160} />;
}
